/* eslint-disable @typescript-eslint/naming-convention, camelcase -- keys mirror the lookup JSON payload */
import React from 'react';
import { highlight } from './highlight';
export function ResultRow({ option, term, onSelect, children }) {
    var _a, _b;
    const typeLine = (_a = option.type_line) !== null && _a !== void 0 ? _a : option.type;
    const title = (_b = option.name) !== null && _b !== void 0 ? _b : option.label;
    const matched = option.matched_field;
    return (React.createElement("button", { type: "button", className: "qmb-control material-search-panel__row", onClick: (e) => {
            e.stopPropagation();
            e.preventDefault();
            onSelect(option);
        } },
        typeLine && React.createElement("small", { className: "material-search-panel__type" }, typeLine),
        React.createElement("span", null, highlight(title, term)),
        matched && (React.createElement("small", { className: "material-search-panel__matched" },
            matched.label,
            ": ",
            highlight(matched.value, term))),
        children));
}
